function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", {
  clipPath: "url(#evotmbjo3a)"
}, React.createElement("path", {
  d: "M44.623 0H6.786A5.804 5.804 0 0 0 .982 5.804v8.392A5.804 5.804 0 0 0 6.786 20h37.837a5.804 5.804 0 0 0 5.804-5.804V5.804A5.804 5.804 0 0 0 44.623 0z",
  fill: "#FFB3C7"
}), React.createElement("path", {
  d: "M40.576 8.763a3.063 3.063 0 1 0 0 5.062v.37h1.738V8.393h-1.738v.371zm-1.58 4.024a1.496 1.496 0 1 1 1.574-1.493 1.536 1.536 0 0 1-1.575 1.493zM16.745 5.806h-1.818v8.39h1.819v-8.39zM32.703 8.236a2.111 2.111 0 0 0-1.79.81v-.654h-1.73v5.804h1.75v-3.05a1.222 1.222 0 0 1 1.305-1.315c.764 0 1.203.456 1.203 1.303v3.062h1.736v-3.69c0-1.352-1.074-2.27-2.474-2.27zM22.243 8.763a3.063 3.063 0 1 0 0 5.062v.37h1.738V8.393h-1.738v.371zm-1.58 4.024a1.495 1.495 0 1 1 1.574-1.493 1.535 1.535 0 0 1-1.574 1.493zM26.67 9.148v-.756h-1.78v5.804h1.783v-2.71c0-.914.991-1.405 1.679-1.405h.02V8.393a2.167 2.167 0 0 0-1.703.756zM44.159 12.137a1.091 1.091 0 1 0 0 2.182 1.091 1.091 0 0 0 0-2.182zM13.673 5.804H11.79a4.82 4.82 0 0 1-1.949 3.89l-.747.56 2.893 3.945h2.38l-2.663-3.63a6.678 6.678 0 0 0 1.97-4.765zM8.863 5.804H6.975v8.394h1.888V5.804z",
  fill: "#000"
}));

var _ref3 = React.createElement("defs", null, React.createElement("clipPath", {
  id: "evotmbjo3a"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(.982)",
  d: "M0 0h49.444v20H0z"
})));

var SvgKlarna = function SvgKlarna(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 51,
    height: 20,
    viewBox: "0 0 51 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKlarna, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/klarna.3e306c7d.svg";
export { ForwardRef as ReactComponent };